import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "edit-transaction-control__overlay" }
const _hoisted_2 = { class: "inventory-control__page-wrap" }
const _hoisted_3 = { class: "inventory-header__title" }
const _hoisted_4 = { class: "inventory-header__wrap" }
const _hoisted_5 = { class: "inventory-tags" }
const _hoisted_6 = { class: "inventory-tag inventory-tag--approval-requested" }
const _hoisted_7 = { class: "inventory-tag inventory-tag--recommended" }
const _hoisted_8 = { class: "inventory-tag inventory-tag--unpaid" }
const _hoisted_9 = { class: "inventory-header__right-content" }
const _hoisted_10 = { class: "inventory-header__wrap" }
const _hoisted_11 = { class: "inventory-header__content" }
const _hoisted_12 = {
  key: 0,
  class: "edit-transaction-control"
}
const _hoisted_13 = { class: "edit-transaction-control__text" }
const _hoisted_14 = { class: "edit-transaction-control__button" }

import { onMounted, ref, StyleValue, computed, onBeforeUnmount, watch, onBeforeMount, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { i18n } from '@/i18n';
import ControlPageTab from '@/corePagesModule/components/ControlPageTab.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useInventoryStore } from './useInventoryStore/';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import { MIN_COLUMN_WIDTH } from '@/corePagesModule/BaseTableContent/constants';
import { InventoryTableViewModel } from './inventoryTableViewModel';
import ToggleSwitch from '@/corePagesModule/components/ToggleSwitch.vue';
import WorkDaysCalendarNotYetEnteredAlertModal from '@/components/modal/WorkDaysCalendarNotYetEnteredAlertModal.vue';
import { shouldShowWorkDaysCalendarNotEnteredAlertModal } from '@/appLogic/importData/calendar';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { isLoading, isZeroMatch, isSuccess } from '@/coreDomainsModule/uiLoadingState';
import CreateGroupModal from '@/corePagesModule/group/components/createGroup/CreateGroupModal.vue';
import AddAggregateBusinessGroupModal from '@/corePagesModule/group/components/addAggregateBusinessGroup/AddAggregateBusinessGroupModal.vue';
import { diContainer } from '@/coreContainer/container';
import EditGroupModal from '@/corePagesModule/group/components/editGroup/EditGroupModal.vue';
import DeleteGroupModal from '@/corePagesModule/group/components/deleteGroup/DeleteGroupModal.vue';
import UpdateGroupNameModal from '@/corePagesModule/group/components/editGroup/UpdateGroupNameModal.vue';
import GroupMenuDropdown from '../components/GroupMenuDropdown.vue';
import GroupListSelectInput from '@/corePagesModule/group/components/GroupListSelectInput.vue';
import { GroupMenuService } from '../domains/services/groupMenuService';
import MoveWarehouseModal from '../components/MoveWarehouseModal.vue';
import VirtualizedEzInventoryTable from '../components/InventoryTable/VirtualizedEzInventoryTable.vue';
import VirtualizedEzOrderTable from '../components/InventoryTable/VirtualizedEzOrderTable.vue';
import UpdateBusinessModals from '@/corePagesModule/updateBusinessModal/UpdateBusinessModals.vue';
import SelectDisplayInventoryYearMonthRangeModal from '../components/SelectDisplayInventoryYearMonthRangeModal.vue';
import inventoryInfoControlMenu from '../components/inventoryInfoControlMenu.vue';
import EditUnpaidOrderedOrderModal from '@/corePagesModule/components/EditUnpaidOrderedOrderModal.vue';
import { useRouter } from 'vue-router';
import CombinedOrderSettingModal from '../components/CombineOrder/CombinedOrderSettingModal.vue';
import { ICombinedOrderConditions } from '../domains/entities/CombinedOrder';
import { CombinedOrderService } from '../domains/services/combinedOrderService';
import { IInventoryOrder, IInventoryOrderInner } from '../domains/entities/InventoryOrder';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { setTemplateFilterState } from './useInventoryStore/inventoryTemplate';
import { RecommendOrderFactory } from '../domains/factories/RecommendOrderFactory';
import OrderBasesModal from '@/corePagesModule/components/OrderBasis/OrderBasesModal.vue';

// 事前準備（DIコンテナ経由でRepositoryを取得）
// 直接インスタンス化は禁止 - diContainerを使用

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const inventoryStore = useInventoryStore();
const { state } = storeToRefs(inventoryStore);
const {
  $reset,
  initTableColumnsWidth,
  onChangePaging,
  fetchState,
  fetchStateWithOpeningChildBusiness,
  switchTableMode,
  closeWorkDaysCalendarNotYetEnteredAlertModal,
  onAppliedFilterModal,
  onSelectedGroupMenu,
  onClosedGroupActionModal,
  onAppliedCreateAggregateBusinessGroup,
  onAppliedAddAggregateBusinessGroup,
  onAppliedEditAggregateBusinessGroup,
  onAppliedDeleteAggregateBusinessGroup,
  onAppliedUpdateNameAggregateBusinessGroup,
  onSwitchedEditTargetGroup,
  onClickedDeleteFromGroupButton,
  onBackToNormalMode,
  resetTableBusinessRowMenuState,
  putEditTransaction,
  setSelectDisplayInventoryYearMonthRangeModalState,
  setInventoryControlMenuStateAndProcessing,
  getFilterItemsValue,
  getFreeColumnFilterItemsValue,
  updateUnpaidOrderedOrder,
} = inventoryStore;

//i18n
const t = i18n.t;

// Router
const router = useRouter();

const inventoryVm = new InventoryTableViewModel();

const tableContainerWidth = ref(0); // ローディングUIの位置を調整するためにコンテナの幅を取得する
const tableContainerHeight = ref(1000); // コンテナの高さを取得する

const isEllipsis = ref(false);

const isRequiredReloadGroups = computed(() => {
  return GroupMenuService.needReloadOnAfterAction(state.value.groupLoadingState.type);
});
const orderBasesModalAggregateBusinessId = computed(() =>
  state.value.businessRowMenuState.orderBasis.modalState ? state.value.businessRowMenuState.businessId : ''
);

const combinedOrderDefaultDesiredDeliveryDate = computed(() => {
  const earliestDate = Object.values(state.value.orderEditData)
    .flatMap((inner) => Object.values(inner))
    .filter((order) => order.status === OrderStatus.Recommended)
    .reduce(
      (acc, order) => {
        if (!order.crossDate) return acc;
        return DateService.compareDates(order.crossDate, acc) === -1 ? order.crossDate : acc;
      },
      { year: 9999, month: 12, day: 31 }
    );
  if (DateService.compareDates(earliestDate, { year: 9999, month: 12, day: 31 }) === 0) {
    return null;
  } else if (DateService.compareDates(earliestDate, DateService.convertDateToIDate(new Date())) !== 1) {
    const nowDate = new Date();
    return DateService.getShiftedIYearMonthByDays(nowDate.getFullYear(), nowDate.getMonth() + 1, nowDate.getDate(), 1);
  } else {
    return earliestDate;
  }
});

/**
 * テキストにマウスオーバーしたときに、テキストが省略されているかどうかを判定する
 * @param e - イベント
 */
const mouseoverTextLabel = (e: MouseEvent) => {
  const { target } = e;
  if (!(target instanceof HTMLElement)) return;
  isEllipsis.value = target.offsetWidth < target.scrollWidth;
};

/**
 * アラートを閉じる処理
 */
const closeAlert = () => {
  state.value.isOpeningAlertBusinessId = '';
};

/**
 * テーブルコンテナのサイズを更新する関数
 */
const updateTableContainerSize = () => {
  const container = document.getElementById('inventory-control');
  if (container) {
    tableContainerWidth.value = container.clientWidth;
    tableContainerHeight.value = state.value.businessRowMenuState.editTransaction.isEditTransactionMode
      ? container.clientHeight - 52
      : container.clientHeight;
    console.log('Table container size updated:', {
      width: tableContainerWidth.value,
      height: tableContainerHeight.value,
    });
  }
};

onBeforeMount(() => {
  // state変数の初期化
  // NOTE: ここで初期化しないと、コンポーネントのマウント時までにstateの表示年月範囲設定が反映されないため
  inventoryStore.$reset();
});

onMounted(async () => {
  state.value.tableLoadingState.status.type = 'loading';
  updateTableContainerSize();
  state.value.workDaysCalendarNotYetEnteredAlertModalStatus = await shouldShowWorkDaysCalendarNotEnteredAlertModal();
  window.addEventListener('scroll', closeAlert);
  window.addEventListener('resize', updateTableContainerSize);
  await initTableColumnsWidth();
  fetchState();
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', closeAlert);
  window.removeEventListener('resize', updateTableContainerSize);
});

watch(
  () => state.value.tableLoadingState.status,
  (newVal) => {
    if (isSuccess(newVal)) {
      const target = document.getElementById('inventory-control');
      if (!target) return;
      let leftScroll = MIN_COLUMN_WIDTH * 2; // アラートの分
      inventoryVm.transactionKeys.forEach((key) => {
        if (key === 'nowInventory') return; //現在庫はスキップ
        leftScroll +=
          (state.value.tableInfos[inventoryVm.getArrivalHeaderKey(key, -1)] ?? MIN_COLUMN_WIDTH) + //現状意図的に大きくしない限りMIN_COLUMN_WIDTHより大きくなることはない
          (state.value.tableInfos[inventoryVm.getArrivalHeaderKey(key, -2)] ?? MIN_COLUMN_WIDTH);
      });
      target.scroll(leftScroll, 0);
    }
  }
);

watch(
  () => state.value.businessRowMenuState.editTransaction.isEditTransactionMode,
  () => {
    updateTableContainerSize();
  }
);

const tableScrollInhibitStyle = computed((): StyleValue => {
  return isSuccess(state.value.tableLoadingState.status) || !state.value.businessRowMenuState.editTransaction.isEditTransactionMode
    ? {}
    : { overflow: 'hidden' };
});

const tableFlowStyle = computed((): StyleValue => {
  return state.value.businessRowMenuState.editTransaction.isEditTransactionMode ? { zIndex: 2 } : null;
});
/**
 * 在庫管理ページの操作メニュー選択ハンドラー
 * @param e - 選択された項目
 */
const handleInventoryControlMenuSelect = async (e: 'excelExport' | 'editDisplayRange' | 'combinedOrderSetting') => {
  if (e === 'excelExport') {
    // フィルター情報をテンプレートページに渡す（型変換はUseCaseで行う）
    const filterItems = getFilterItemsValue().value;
    setTemplateFilterState(filterItems && filterItems.length > 0 ? filterItems : undefined);
    // CSVエクスポートの場合は、テンプレート設定ページにリダイレクト
    router.push({ name: 'inventory-template' });
    return;
  }
  // それ以外は既存の処理を実行
  await setInventoryControlMenuStateAndProcessing(e);
};

/**
 * まとめ発注案作成ボタン押下時の処理
 * @param combinedOrderSetting - まとめ発注設定
 */
const onConfirmCombinedOrder = async (combinedOrderSetting: ICombinedOrderConditions) => {
  /**
   * orderEditDataのフォールバック関数
   */
  const _makeFallBack = () =>
    RecommendOrderFactory.create({
      amount: NaN,
      crossDate: DateService.convertDateToIDate(new Date()),
    });

  state.value.combinedOrdersState.settingModalStatus = 'progress';

  // 処理が長いとフリーズしているように見えるので、setTimeoutでレンダリング待ってから処理実行
  const calcedCombinedOrder = await new Promise<{
    maxTotalAmount: number;
    data: IInventoryOrder;
  } | null>((resolve) => {
    setTimeout(() => {
      resolve(
        CombinedOrderService.calculateCombinedOrder(
          combinedOrderSetting,
          state.value.summaryData,
          state.value.businessList,
          state.value.monthlyData
        )
      );
    }, 0);
  });

  state.value.combinedOrdersState.settingModalStatus = 'close';

  if (calcedCombinedOrder !== null) {
    const createdOrderEditData: IInventoryOrder = {};
    for (const key of Object.keys(state.value.orderEditData)) {
      const inner = state.value.orderEditData[key];
      const createdOrderEditDataInner: Record<number, IInventoryOrderInner> = {};
      for (const i of Object.keys(inner)) {
        const iNum = Number(i);
        createdOrderEditDataInner[iNum] = calcedCombinedOrder.data[key]?.[iNum] ?? _makeFallBack();
      }
      createdOrderEditData[key] = createdOrderEditDataInner;
    }

    state.value.orderEditData = createdOrderEditData;
    state.value.combinedOrdersState.combinedOrderContents.maxTotalAmount = calcedCombinedOrder.maxTotalAmount;
    state.value.checkedAggregateBusinessIds = Object.keys(calcedCombinedOrder.data);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
      [_vShow, _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('管理表')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ControlPageTab, { class: "inventory-tabs" }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('推奨')), 1)
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "status-dot status-dot--approval-requested" }, null, -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('承認依頼')), 1)
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "status-dot status-dot--recommended" }, null, -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('未納')), 1)
          ]),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "status-dot status-dot--unpaid" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_unref(state).pageMode === 'order')
            ? (_openBlock(), _createBlock(TextButton, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).combinedOrdersState.settingModalStatus = 'generate'))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('まとめ発注案の生成')), 1)
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(state).pageMode !== 'editGroup')
            ? (_openBlock(), _createBlock(ToggleSwitch, {
                key: 1,
                class: "inventory-header__toggle",
                "is-enabled": _unref(state).pageMode === 'order',
                onOnToggled: _unref(switchTableMode)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('発注を表示する')), 1)
                ], undefined, true),
                _: 1
              }, 8, ["is-enabled", "onOnToggled"]))
            : _createCommentVNode("", true),
          _createVNode(inventoryInfoControlMenu, {
            class: "inventory-header__info-control-menu",
            "tool-tip-message": undefined,
            disabled: _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode,
            onSelect: _cache[1] || (_cache[1] = ($event: any) => (handleInventoryControlMenuSelect($event)))
          }, null, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(FilterModalButton, {
            "filter-modal-type": "inventory",
            "select-input-index": 5,
            "filter-items": _unref(getFilterItemsValue)().value,
            "free-column-filter-items": _unref(getFreeColumnFilterItemsValue)().value,
            onApply: _unref(onAppliedFilterModal)
          }, null, 8, ["filter-items", "free-column-filter-items", "onApply"]),
          (_unref(state).pageMode === 'editGroup')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(GroupListSelectInput, {
                  class: "edit-group__select-input",
                  "select-input-index": 1,
                  "store-tag": 'editGroupModeInventoryControl',
                  "selected-group-id-prop": _unref(state).editGroupModeState.selectedEditGroupId,
                  reload: isRequiredReloadGroups.value,
                  "use-reset": false,
                  "use-teleport": "",
                  onSelectedGroup: _cache[2] || (_cache[2] = (groupId) => _unref(onSwitchedEditTargetGroup)(groupId))
                }, null, 8, ["selected-group-id-prop", "reload"]),
                _createVNode(TextButton, {
                  class: "edit-group__update-name-button",
                  "button-style": 'btn-primary',
                  size: 'btn-md',
                  disabled: _unref(state).editGroupModeState.selectedEditGroupId === '',
                  onClick: _cache[3] || (_cache[3] = () => (_unref(state).editGroupModeState.updateGroupNameModalState = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('グループ名を編集')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(TextButton, {
                  class: "edit-group__delete-from-group-button",
                  "button-style": 'btn-primary',
                  size: 'btn-md',
                  disabled: _unref(state).checkedAggregateBusinessIds.length === 0,
                  onClick: _cache[4] || (_cache[4] = () => _unref(onClickedDeleteFromGroupButton)(_unref(diContainer).groupRepository))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('グループから外す')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(TextButton, {
                  class: "edit-group__cancel-button",
                  "button-style": 'btn-cancel',
                  size: 'btn-md',
                  onClick: _cache[5] || (_cache[5] = () => _unref(onBackToNormalMode)())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('元のページに戻る')), 1)
                  ], undefined, true),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createBlock(GroupMenuDropdown, {
                key: 1,
                "is-selected-businesses": _unref(state).checkedAggregateBusinessIds.length > 0,
                "is-open-prop": _unref(state).isOpenGroupMenuDropdown,
                "selected-item-prop": _unref(state).selectedGroupMenu,
                "onClick:selectInput": _cache[6] || (_cache[6] = () => (_unref(state).isOpenGroupMenuDropdown = true)),
                onClose: _cache[7] || (_cache[7] = () => (_unref(state).isOpenGroupMenuDropdown = false)),
                onSelectedItem: _cache[8] || (_cache[8] = 
            (item) => {
              _unref(onSelectedGroupMenu)(item);
            }
          )
              }, null, 8, ["is-selected-businesses", "is-open-prop", "selected-item-prop"]))
        ]),
        (_unref(state).pagingOptions)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 0,
              class: "inventory-header__pagination",
              "paging-options": _unref(state).pagingOptions,
              "is-loading": _unref(isLoading)(_unref(state).tableLoadingState.status),
              "is-inventory-page": "",
              onOnChangePage: _cache[9] || (_cache[9] = ($event: any) => (_unref(onChangePaging)($event)))
            }, null, 8, ["paging-options", "is-loading"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        id: "inventory-control",
        class: "inventory-control base-table-wrapper",
        style: _normalizeStyle(tableFlowStyle.value),
        onScroll: closeAlert
      }, [
        (_unref(state).businessRowMenuState.editTransaction.isEditTransactionMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('数値データ編集中')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(TextButton, {
                  size: "btn-sm",
                  onClick: _unref(putEditTransaction)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(TextButton, {
                  "button-style": "btn-secondary",
                  size: "btn-sm",
                  onClick: _cache[10] || (_cache[10] = 
              () => {
                _unref($reset)();
                _unref(fetchState)();
              }
            )
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
                  ], undefined, true),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "",
          style: _normalizeStyle(tableScrollInhibitStyle.value)
        }, [
          (_unref(state).pageMode !== 'order')
            ? (_openBlock(), _createBlock(VirtualizedEzInventoryTable, {
                key: 0,
                "table-container-width": tableContainerWidth.value,
                "table-container-height": tableContainerHeight.value,
                "is-ellipsis": isEllipsis.value,
                "transaction-months": _unref(state).transactionMonths,
                "mouseover-text-label": mouseoverTextLabel
              }, null, 8, ["table-container-width", "table-container-height", "is-ellipsis", "transaction-months"]))
            : (_openBlock(), _createBlock(VirtualizedEzOrderTable, {
                key: 1,
                "table-container-width": tableContainerWidth.value,
                "table-container-height": tableContainerHeight.value,
                "is-ellipsis": isEllipsis.value,
                "transaction-months": _unref(state).transactionMonths,
                "mouseover-text-label": mouseoverTextLabel
              }, null, 8, ["table-container-width", "table-container-height", "is-ellipsis", "transaction-months"])),
          _createVNode(InfoModal, {
            "modal-state": _unref(isLoading)(_unref(state).editOrderInfoLoadingState.status),
            icon: "loading",
            "enable-outside-click": false
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('データを保存しています')), 1)
            ]),
            _: 1
          }, 8, ["modal-state"]),
          _createVNode(InfoModal, {
            "modal-state": _unref(isLoading)(_unref(state).editMemoLoadingState.state.status),
            icon: "loading",
            "enable-outside-click": false
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(state).editMemoLoadingState.isDelete ? _unref(t)('メモを削除しています') : _unref(t)('メモを保存しています')), 1)
            ]),
            _: 1
          }, 8, ["modal-state"]),
          _createVNode(InfoModal, {
            "modal-state": _unref(isZeroMatch)(_unref(state).editMemoLoadingState.state.status),
            icon: "error",
            "color-style": "error",
            "back-button-label": "OK",
            "enable-outside-click": false,
            onOnBack: _cache[11] || (_cache[11] = 
            () => {
              _unref(state).editMemoLoadingState = {
                state: {
                  status: {
                    type: 'none',
                  },
                },
                dataType: 'none',
                isDelete: false,
              };
              _unref(state).isOpeningBusinessId = '';
              _unref(fetchState)();
              return;
            }
          )
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('エラーが発生しました')), 1)
            ]),
            description: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(state).editMemoLoadingState.dataType === 'aggregateBusiness'
                ? _unref(t)('指定された集計情報は未登録か、すでに削除されています。')
                : _unref(t)('指定された取引情報は未登録か、すでに削除されています。')), 1),
              _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_unref(t)('OKボタンを押すとテーブルを更新します。')), 1)
            ]),
            _: 1
          }, 8, ["modal-state"])
        ], 4)
      ], 36),
      _createVNode(InfoModal, {
        "modal-state": _unref(isLoading)(_unref(state).groupLoadingState.state.status),
        icon: "loading",
        "enable-outside-click": false
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(GroupMenuService).getLoadingText(_unref(state).groupLoadingState.type)), 1)
        ]),
        _: 1
      }, 8, ["modal-state"]),
      _createVNode(WorkDaysCalendarNotYetEnteredAlertModal, {
        "is-open-modal": _unref(state).workDaysCalendarNotYetEnteredAlertModalStatus,
        onOutsideClick: _unref(closeWorkDaysCalendarNotYetEnteredAlertModal)
      }, null, 8, ["is-open-modal", "onOutsideClick"]),
      _createVNode(CreateGroupModal, {
        "modal-state": _unref(state).selectedGroupMenu === 'CreateGroup',
        onClose: _unref(onClosedGroupActionModal),
        onApply: _cache[12] || (_cache[12] = 
        (inputText) => {
          _unref(onAppliedCreateAggregateBusinessGroup)(_unref(diContainer).groupRepository, inputText);
        }
      )
      }, null, 8, ["modal-state", "onClose"]),
      _createVNode(AddAggregateBusinessGroupModal, {
        "modal-state": _unref(state).selectedGroupMenu === 'AddBusinessToGroup',
        "select-input-index": 1,
        onClose: _unref(onClosedGroupActionModal),
        onApply: _cache[13] || (_cache[13] = 
        (selectedGroupId) => {
          _unref(onAppliedAddAggregateBusinessGroup)(_unref(diContainer).groupRepository, selectedGroupId);
        }
      )
      }, null, 8, ["modal-state", "onClose"]),
      _createVNode(EditGroupModal, {
        "modal-state": _unref(state).selectedGroupMenu === 'EditGroup',
        "select-input-index": 2,
        onClose: _unref(onClosedGroupActionModal),
        onApply: _cache[14] || (_cache[14] = 
        (selectedGroupId, selectedGroupName) => {
          _unref(onAppliedEditAggregateBusinessGroup)(_unref(diContainer).inventoryRepository, selectedGroupId, selectedGroupName);
        }
      )
      }, null, 8, ["modal-state", "onClose"]),
      _createVNode(DeleteGroupModal, {
        "modal-state": _unref(state).selectedGroupMenu === 'DeleteGroup',
        "select-input-index": 3,
        onClose: _unref(onClosedGroupActionModal),
        onApply: _cache[15] || (_cache[15] = 
        (selectedGroupId) => {
          _unref(onAppliedDeleteAggregateBusinessGroup)(_unref(diContainer).inventoryRepository, _unref(diContainer).groupRepository, selectedGroupId);
        }
      )
      }, null, 8, ["modal-state", "onClose"]),
      _createVNode(UpdateGroupNameModal, {
        "modal-state": _unref(state).editGroupModeState.updateGroupNameModalState,
        "select-input-index": 4,
        "target-group-id": _unref(state).editGroupModeState.selectedEditGroupId,
        "current-group-name": _unref(state).editGroupModeState.selectedEditGroupName,
        onClose: _cache[16] || (_cache[16] = () => (_unref(state).editGroupModeState.updateGroupNameModalState = false)),
        onApply: _cache[17] || (_cache[17] = 
        (inputText) => {
          _unref(onAppliedUpdateNameAggregateBusinessGroup)(_unref(diContainer).groupRepository, inputText);
        }
      )
      }, null, 8, ["modal-state", "target-group-id", "current-group-name"]),
      _createVNode(MoveWarehouseModal),
      _createVNode(InfoModal, {
        "modal-state": _unref(state).moveWarehouseModalState.isLoadingModalOpen,
        icon: "loading",
        "enable-outside-click": false
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('ローディング中')), 1)
        ]),
        _: 1
      }, 8, ["modal-state"]),
      _createVNode(InfoModal, {
        "modal-state": _unref(state).moveWarehouseModalState.isSuccessModalOpen,
        "back-button-label": _unref(t)('閉じる'),
        icon: "info",
        "enable-outside-click": "",
        onOnBack: _cache[18] || (_cache[18] = ($event: any) => (_unref(state).moveWarehouseModalState.isSuccessModalOpen = false))
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('置場移動の登録を完了しました。')), 1)
        ]),
        _: 1
      }, 8, ["modal-state", "back-button-label"]),
      _createVNode(UpdateBusinessModals, {
        "is-opening-aggregate-business-edit": 
        _unref(state).businessRowMenuState.edit.isEditingModalOpen && _unref(state).businessRowMenuState.businessType === 'aggregateBusiness'
      ,
        "is-opening-base-business-edit": 
        _unref(state).businessRowMenuState.edit.isEditingModalOpen && _unref(state).businessRowMenuState.businessType === 'baseBusiness'
      ,
        "is-create-mode": _unref(state).businessRowMenuState.edit.isCreateMode,
        item: _unref(state).businessRowMenuState.item,
        onClose: _unref(resetTableBusinessRowMenuState),
        onSuccess: _cache[19] || (_cache[19] = 
        async () => {
          _unref(resetTableBusinessRowMenuState)();
          await _unref(fetchStateWithOpeningChildBusiness)();
        }
      )
      }, null, 8, ["is-opening-aggregate-business-edit", "is-opening-base-business-edit", "is-create-mode", "item", "onClose"]),
      _createVNode(SelectDisplayInventoryYearMonthRangeModal, {
        "default-start-year-month": _unref(state).selectDisplayInventoryYearMonthRangeModalState.startYearMonth,
        "default-end-year-month": _unref(state).selectDisplayInventoryYearMonthRangeModalState.endYearMonth,
        "modal-state": _unref(state).selectDisplayInventoryYearMonthRangeModalState.isOpen,
        onOnNext: _cache[20] || (_cache[20] = ($event: any) => (_unref(setSelectDisplayInventoryYearMonthRangeModalState)($event))),
        onOnBack: _cache[21] || (_cache[21] = ($event: any) => (_unref(state).selectDisplayInventoryYearMonthRangeModalState.isOpen = false))
      }, null, 8, ["default-start-year-month", "default-end-year-month", "modal-state"]),
      _createVNode(EditUnpaidOrderedOrderModal, {
        "modal-state": _unref(state).editUnpaidOrderedOrderModalState.isOpening,
        "unpaid-ordered-orders": _unref(state).editUnpaidOrderedOrderModalState.unpaidOrderedOrder,
        "execution-date": _unref(state).editUnpaidOrderedOrderModalState.executionDate,
        onClose: _cache[22] || (_cache[22] = ($event: any) => (_unref(state).editUnpaidOrderedOrderModalState.isOpening = false)),
        onConfirm: _unref(updateUnpaidOrderedOrder)
      }, null, 8, ["modal-state", "unpaid-ordered-orders", "execution-date", "onConfirm"]),
      _createVNode(CombinedOrderSettingModal, {
        "modal-state": _unref(state).combinedOrdersState.settingModalStatus,
        "default-desired-delivery-date": combinedOrderDefaultDesiredDeliveryDate.value,
        onClose: _cache[23] || (_cache[23] = ($event: any) => (_unref(state).combinedOrdersState.settingModalStatus = 'close')),
        onConfirm: onConfirmCombinedOrder
      }, null, 8, ["modal-state", "default-desired-delivery-date"]),
      _createVNode(OrderBasesModal, {
        "aggregate-business-id": orderBasesModalAggregateBusinessId.value,
        onClose: _unref(resetTableBusinessRowMenuState)
      }, null, 8, ["aggregate-business-id", "onClose"])
    ])
  ], 64))
}
}

})